import { ImageUpload } from '@/components/ImageUpload'
import { useTranslation } from 'react-i18next'

export function TransferImageList({ imageIds }: { imageIds: string[] }) {
  const { t } = useTranslation()

  if (imageIds.length === 0) return null

  return (
    <div className="rounded-lg border border-border/30 p-3">
      <p className="text-[10px] text-muted-foreground">{t('common.images')}:</p>
      <div className={'mt-2'}>
        <ImageUpload files={[]} imageIds={imageIds} onChange={() => {}} maxImages={imageIds.length} readonly />
      </div>
    </div>
  )
}
